
import React, { FC, ReactNode } from 'react';
import { MemberCardWrap } from './style';
import { IPOAvatar } from '../../../styles';
import { IMember } from '../account';

import cardIcon from '../../../images/components/card/bg.svg';
import cardTeamIcon from '../../../images/components/card/bg2.svg';
import { TagCard } from '../../Tag';
import { Avatar } from 'antd';
import { IPOTooltip } from '../../../styles/components/IPOTooltip';

interface IUserCardProps {
	id?: string;
	userInfo: IMember
	buttonNode?: ReactNode;
	baseUrl?: string;
	zIndex?: number;
}

export const MemberCard: FC<IUserCardProps> = (props) => {
	const { userInfo, baseUrl, zIndex = 99997 } = props;

	return (
		<MemberCardWrap isMyTeam={userInfo?.myTeam ? true : false}>
			<div className="content">
				<div className='left'>
					<div className='avatar-wrap'>
						<div>
							<div className="primary-name">
								<IPOTooltip maxShowNum={userInfo.activateFlag == 0 ? 7 : 12} text={userInfo.name ? userInfo.name : (userInfo.name2 ? userInfo.name2 : userInfo.mobile)} />
								{userInfo.activateFlag == 0 && <span className='activa-state'>(未激活)</span>}
							</div>
							<div className="inferior-name">{userInfo.name2 ? userInfo.name2 : '-'}</div>
							<div className="flex-row">
								<div className="ipo-label">手机：</div>
								<div className="info">{userInfo.mobile}</div>
							</div>
						</div>
						<div className='griht-avatar'>
							<IPOAvatar size={60} info={{ ...userInfo, baseUrl: baseUrl ?? '' }} />
						</div>
					</div>
					<div className="flex-row">
						<div className="ipo-label">邮箱：</div>
						<div className="info">{userInfo.email ? userInfo.email : '-'}</div>
					</div>
					{
						userInfo?.myTeam && <div className="flex-row flex-row-team">
							<div className="ipo-label">所在团队：</div>
							<div className="info">{userInfo.myTeam ? userInfo.myTeam : '-'}</div>
						</div>
					}
					<div className={userInfo?.myTeam ? "flex-row flex-row-team" : "flex-row"}>
						<div className="ipo-label">团队标签：</div>
						<div className="info">
							<Avatar.Group
								maxCount={4}
								maxStyle={{
									display: 'flex',
									fontSize: '14px',
									textAlign: 'center',
									lineHeight: '22px',
								}}>
								{userInfo.teams.map(tag => <TagCard key={tag.id} tag={tag} baseUrl={baseUrl ?? ''} zIndex={zIndex + 1} />)}
							</Avatar.Group>
						</div>
					</div>
					<div className={userInfo?.myTeam ? "flex-row flex-row-team" : "flex-row"}>
						<div className="ipo-label">专业标签：</div>
						<div className="info">
							<Avatar.Group maxCount={4} maxStyle={{
								display: 'flex',
								fontSize: '14px',
								textAlign: 'center',
								lineHeight: '22px',
							}}>
								{userInfo.ability.map(tag => <TagCard
									key={tag.id}
									tag={tag}
									baseUrl={baseUrl ?? ''}
									zIndex={zIndex + 1}
									isMargin={true}
									isBox={true} />
								)}
							</Avatar.Group>
						</div>
					</div>
				</div>
				{/* <div className='right'>
					{buttonNode}
				</div> */}
			</div>
			<img src={userInfo?.myTeam ? cardTeamIcon : cardIcon} alt="" className='member-bg-img' />
		</MemberCardWrap >
	);
};
